import type { TourStep } from "@shared/lib/walkthrough/types";

export const tourSteps: TourStep[] = [
  {
    target: "classrooms-glance",
    title: "Your Classrooms",
    description:
      "Tap a classroom to see the roster and check-in status. The ring color shows ratio compliance.",
  },
  {
    target: "activity-fab",
    title: "Log Activity",
    description:
      "Tap the plus button to record meals, naps, diaper changes, or group activities.",
  },
  {
    target: "qr-checkin",
    title: "QR Check-In",
    description:
      "Tap here to clock in at your center using the QR scanner.",
  },
  {
    target: "tab-schedule",
    title: "Your Schedule",
    description:
      "View your weekly shifts, time-off requests, and upcoming schedule changes.",
  },
  {
    target: "tab-bar",
    title: "Navigation",
    description:
      "Switch between Home, Schedule, Messages, and Profile using the bottom tabs.",
  },
];
